import styled from '@emotion/styled';

export const CUSTOM_BREAK_POINT = 1050;
export const MOBILE_BREAK_POINT = 550;

export const BlockWrapper = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8rem;

  position: relative;
  background-color: var(--bg-color);
  padding: 10rem 0rem;

  font-style: normal;
  color: #fff;
`;

export const BlockHeader = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;

  text-align: center;
`;

export const BlockTitle = styled.div`
  font-size: 55px;
  color: #ffffff;
  text-transform: uppercase;
  font-family: 'Titan One', Arial, Helvetica, sans-serif;
`;

export const StroySubTitle = styled.h1`
  font-weight: 800;
  font-size: 2.5rem;
  line-height: 130%;
`;

export const BlockDescription = styled.p`
  word-break: break-word;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  font-size: 24px;
`;

export const BlockContentWrapper = styled.section`
  /* position: relative; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20rem;

  width: 100%;
`;

export const BlockContentTitle = styled.div`
  font-weight: 700;
  font-size: 1.1rem;
  padding: 1.1rem 1.4rem;
  background: darkgray;
  border-radius: 10rem;
  opacity: 0.7;
`;

export const BackgroundImage = styled.img<{
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
  size: number;
}>`
  position: absolute;
  top: ${(props) => props.top}px;
  bottom: ${(props) => props.bottom}px;
  left: ${(props) => props.left}px;
  right: ${(props) => props.right}px;

  width: fit-content;
  height: ${(props) => props.size}px;
  object-fit: contain;

  opacity: 0.3;
`;
